import React from "react";
import { Container, Row,Col} from "react-bootstrap";

const Policy = () => {
  return (
    <>
      <Container style={{ marginTop: "50px" }}>
        <h1>Terms and Policy</h1>
        <Row>
          <Col md={10}>
            <h6>
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Culpa,
              quia.
            </h6>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipisicing elit. Rerum
              nihil omnis quisquam repellat eos vitae ullam optio velit
              blanditiis corporis quam perspiciatis aut voluptatum vero quis eum
              fugit nemo nulla eius voluptates, asperiores dolores doloribus
              illo magnam? Odio doloremque suscipit earum explicabo autem ipsum
              laborum quibusdam velit saepe nostrum corporis at itaque corrupti
              distinctio quis, reiciendis commodi, voluptatum adipisci dolore
              impedit, fugiat nesciunt consequuntur quam. Quisquam, asperiores!
              Error accusamus fuga nihil, aliquid tempore expedita voluptas sint
              et id repellat magni alias, aliquam, doloribus minima! Nesciunt,
              omnis aspernatur laboriosam doloremque autem ad, corrupti, iste
              amet nihil sapiente nam possimus? Dicta, quasi.
            </p>
            <h6>
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Delectus
              excepturi soluta eos laborum ipsam perferendis, impedit cum
              repellendus eius tempora?
            </h6>
            <p>
              Lorem ipsum dolor sit, amet consectetur adipisicing elit.
              Accusamus, quas voluptas nihil laudantium qui provident maxime vel
              mollitia sapiente labore odio eveniet molestias cumque eligendi
              sequi tempora. Molestias iusto commodi illo sapiente possimus
              architecto autem eligendi, voluptas eum consequuntur inventore,
              ratione nesciunt officia veritatis recusandae a dolor ad harum,
              itaque cupiditate. Accusantium excepturi numquam aperiam, ducimus
              quis, quidem, fuga labore delectus veniam ipsum harum enim
              voluptate nam corporis! Quisquam delectus vitae assumenda
              praesentium officia eius ea voluptas alias, facere rerum sed
              laborum dolor eos, debitis iure quidem dolores? Unde labore quas
              officiis nostrum magnam adipisci exercitationem eveniet tempora ad
              ea.
            </p>
            <h6>
              Lorem ipsum dolor sit, amet consectetur adipisicing elit. Beatae,
              ducimus. Nesciunt est veritatis eveniet, consequuntur asperiores
              quae porro dolorem mollitia.
            </h6>
            <p>
              Lorem, ipsum dolor sit amet consectetur adipisicing elit. Ullam
              quas maiores, officiis molestias quibusdam dolorum delectus totam,
              sequi tenetur temporibus iste sed in deserunt distinctio, suscipit
              perspiciatis nulla praesentium repellendus quis saepe? Iste
              veritatis sunt doloribus! Aut iure eligendi maxime aliquid veniam,
              dolorem odio accusantium non, aperiam, ipsa incidunt fugiat?
              Voluptates harum nisi repudiandae maxime et, ducimus sit mollitia
              totam distinctio fugit, alias placeat expedita sed dolor ipsum
              aperiam ullam necessitatibus rerum explicabo. Quos nam quis
              facilis explicabo ipsum autem. Quia nulla eius, labore dolore vero
              possimus? Sed doloribus earum nobis ipsa fugiat laudantium, ipsam
              corrupti facilis tempore hic? Nostrum soluta quam dolor, ipsam
              nesciunt id tenetur? Temporibus doloremque saepe quam repellat,
              dignissimos reprehenderit eos blanditiis provident ducimus laborum
              facere itaque optio molestiae delectus deleniti quos? Distinctio
              amet nulla expedita beatae animi nobis ab. Est aspernatur magni
              aliquid harum necessitatibus quo vero beatae culpa mollitia.
              Consequatur saepe corrupti eaque a vero, iusto sequi veritatis
              dolores doloribus voluptate, quod placeat deserunt ex modi quas
              illum. Sunt eum ducimus consectetur et quidem illum eius ab
              explicabo quisquam iure placeat, architecto esse expedita facere
              non ipsam vero temporibus tenetur animi. Dolore asperiores
              temporibus quaerat nostrum repellendus, sed magnam alias hic
              suscipit impedit voluptatum fugiat, officiis quisquam consequatur
              adipisci nulla assumenda molestiae. Id pariatur cum iste! Ipsam
              sint distinctio vero? Est dignissimos totam omnis eveniet
              temporibus modi odit, necessitatibus libero, molestias dicta
              placeat earum rem, nesciunt esse iusto perferendis repellendus
              harum eligendi! Sed, quis eius! Doloremque, dolorem ad beatae
              exercitationem facilis explicabo similique est accusamus, magni
              unde vitae dolorum nobis quis cupiditate laudantium deleniti sunt
              animi. Quis fuga quos ea a saepe sapiente odit nesciunt unde
              laborum labore dolorem, nam quaerat reprehenderit totam, iure
              tempore quia voluptatum magnam illum ipsam veniam illo perferendis
              perspiciatis adipisci. Neque voluptatem esse blanditiis dicta
              cupiditate ratione sit tempore!
            </p>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Policy;
